import styles from '@/styles/productDetail/productDetail.module.scss'
import Link from 'next/link'
import productApi from '@/service/modules/productApi'
import { useEffect, useState } from 'react'
import { message } from 'antd'

export default function FineMore(props: any) {

  const [fineMoreList, setFineMoreList] = useState([])
  useEffect(() => {
    if (props.id) {
      getFineMoreList()
    }
    if (props.breadcrumb) {
      const newList: any = [
        { name: "Online Shopping", url: "/" },
        ...props.breadcrumb,
        { name: "Deals Direct", url: "/hottest-deals" }
      ]
      setFineMoreList(newList)
    }
  }, [])



  const getFineMoreList = async () => {
    try {
      let res = await productApi.getFineMore(props.productID)
      if (res.data) {
        setFineMoreList(res.data)
      }
    } catch (error: any) {
      console.error(error)
    }
  }
  return (
    <>
      {
        fineMoreList.length > 0
        &&
        <div className={styles['fineMore']}>
          <div className={styles['list']}>
            <div className={styles['title']}>Find More:</div>
            {
              fineMoreList.map((item: any, index: number) => (
                <div className={styles['item']} key={index}>
                  <Link
                    href={item.url}
                    legacyBehavior
                  >
                    <a className={styles['link']} target="_blank" rel="noopener noreferrer">{item.name}</a>
                  </Link>
                </div>
              ))
            }

          </div>
        </div>
      }
    </>

  )
}